'use client';

import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import Play from '../../components/svg/YoutubePlayButton';
import Image from 'next/image';
import FallBackImage from '../../components/FallBackImage';


interface Props {
  title: string;
  src: string;
  placeholder: string;
  alt: string;
  thumbnail: string;
  
}

export default function VideoPlayer({title, src, placeholder, alt, thumbnail}: Props) {
  const [init, setInit] = useState(false);

  if (init) {
    return (
      <iframe
      width="100%"
      height="100%"
      className='h-full w-full'
      src={src}
      title={title}
      allow="accelerometer; clipboard-write; encrypted-media; gyroscope;"
      allowFullScreen
      />
    )
  }
  else {
    return (
      <div 
        className={twMerge('relative w-full h-full cursor-pointer')}
        onClick={() => setInit(true)}
      >
        <Play className='h-[30px] w-[30px] aspect-square z-[4] absolute bottom-[3px] right-[3px]' />
      <FallBackImage
        fill
        className='tablet:rounded-[12px] aspect-[16/9] w-full'
        sizes='100vw'
        src={placeholder}
        alt={alt}
        thumbnail={thumbnail}
      />
      </div>
    )
  }


}